export const admimMenu = [
  {
    title: 'Dashboard',
    path: '/news/lists',
    icon: 'fas fa-tachometer-alt',
    subMenuCollapse: false,
    submenu: []
  }
];



// WEBPACK FOOTER //
// /home/vatzcar/public_html/Exchange-NewsAdmin-Frontend/src/app/config/adminMenuConfig/admin.menu.ts